import { NgModule } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { LoadingModule } from 'ngx-loading';
import { FormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { PermissionsComponent } from './permissions/permissions.component';
import { RolesComponent } from './roles/roles.component';
import {routes} from './rights.routing';
import { FormComponent as RolesFormComponent } from './roles/form/form.component';
import { ListComponent } from './roles/list/list.component';
import { SelectComponent } from './roles/select/select.component';

@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      LoadingModule,
      NgxDatatableModule,
      RouterModule.forChild(routes),
      NgxPermissionsModule.forChild(),
      NgbTooltipModule,
      ReactiveFormsModule
  ],
  declarations: [
      PermissionsComponent,
      RolesComponent,
      RolesFormComponent,
      ListComponent,
      SelectComponent
  ],
   exports:[
     ListComponent,
     SelectComponent
   ]
})
export class RightsModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/rights/rights.module.ts